import { CreditsSection } from 'src/v2/pages/manageUsersInWorkspace/components/CreditsSection';
import { AddOnContainer } from '../AddOnContainer';
import { Button } from 'src/v2/commonComponents/Button';
import styles from './AddOnCredits.module.scss';
import { API_DOC_LINK } from 'src/constants/externalLinks';
import { SVG_SIZE_M } from 'src/constants';
import { ArrowSquareOut } from '@phosphor-icons/react';
import { ModelPricing } from 'src/pages/ManageAccountPage/components/ModelPricing';
import { useFeatureFlagEnabled } from 'posthog-js/react';

export const AddOnCredits = () => {
  const modelPricingEnabled = useFeatureFlagEnabled('modelPricing');

  return (
    <AddOnContainer>
      <div className={styles.root}>
        <CreditsSection />

        {modelPricingEnabled && (
          <>
            <hr className="divider" />
            <ModelPricing />
          </>
        )}

        <Button
          href={API_DOC_LINK}
          target="_blank"
          rel="noreferrer"
          className={styles.link}
          color="link"
          as="a"
        >
          <span>Learn more about Ninja API</span>
          <ArrowSquareOut size={SVG_SIZE_M} />
        </Button>
      </div>
    </AddOnContainer>
  );
};
